var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"py-4 pt-15",attrs:{"id":"progressbar"}},_vm._l((_vm.value),function(item){return _c('li',{key:item.label,class:{active: item.isActive}},[_vm._v(_vm._s(item.label))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }